import { UIActionType, UIAction } from '../../actions/uiActions';

const processesStatisticsFilterReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_PROCESSES_STATISTICS_FILTER) return action.value;
  return state;
};

export default processesStatisticsFilterReducer;
